import { setSuccessedDepositsCounterCookie, getSuccessedDepositsCounterCookie } from 'helpers/cookiesHelper.js';
import { pushCustomEventToGoogleAnalytics } from 'helpers/utilsHelper';
import _isObject from 'lodash/isObject';

const processCustomerDepositData = ({depositCounter, depositInfo, userId}) =>{

  if(process.env.DEPOSIT_COUNTER_DATA_LAYER_ENABLED && JSON.parse(process.env.DEPOSIT_COUNTER_DATA_LAYER_ENABLED) && depositInfo){
    processDepositDataLayer({depositCounter, depositInfo, userId});
  }
  setSuccessedDepositsCounterCookie(`${depositCounter || 0}`);

}

const processDepositDataLayer = ({depositCounter, depositInfo, userId}) => {
  const date = new Date();
  const cookieCounter = getSuccessedDepositsCounterCookie();
  const depositData = _isObject(JSON.parse(depositInfo)) ? JSON.parse(depositInfo) : JSON.parse(JSON.parse(depositInfo));
  if(checkIfFirstDeposit(date, depositData, depositCounter, cookieCounter)){
    pushCustomEventToGoogleAnalytics({
      'event': 'firstDeposit',
      'category': 'conversion',
      'userId': userId,
      'value': depositData.lastDepositAmount
    })
    window.history.replaceState({}, null, '#FirstDeposit');
    app.system.render(app.modal.FirstDeposit)
  } else if(checkIfReturnDeposit(date, depositData, depositCounter, cookieCounter)){
    pushCustomEventToGoogleAnalytics({
      'event': 'returnDeposit',
      'category': 'conversion',
      'userId': userId,
      'value': depositData.lastDepositAmount
    })
  }
}

const checkIfFirstDeposit = (date, {firstDepositTime, lastDepositTime}, depositCounter, cookieCounter) => {

  const firstDeposit = new Date(firstDepositTime).getTime();
  const lastDeposit = new Date(lastDepositTime).getTime();
  
  if((firstDeposit >= (date.getTime() - 300000)) && (firstDeposit < date.getTime())){
    if((firstDeposit === lastDeposit && depositCounter == 1)){
      return true
    }
  }

}

const checkIfReturnDeposit = (date, {firstDepositTime, lastDepositTime}, depositCounter, cookieCounter) => {

  const firstDeposit = new Date(firstDepositTime).getTime();
  const lastDeposit = new Date(lastDepositTime).getTime();
  
  if((firstDeposit != lastDeposit) && (lastDeposit >= (date.getTime() - 30000)) && (lastDeposit < date.getTime())){
    if(cookieCounter > 1 && depositCounter > 1 && cookieCounter != depositCounter){
      return true;
    }
  }

}

export {
  processCustomerDepositData
}